import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'People',
                topics: [
                    'Building and managing effective teams',
                    'Hiring and retaining top technical talent',
                    'Developing and mentoring team members',
                    'Leading through change and uncertainty',
                    'Creating a culture of innovation and continuous learning',
                    'Empowering team members to take ownership and make decisions',
                    'Managing conflicts and difficult conversations',
                    'Overcoming common challenges in mentorship programs and ensuring their success',
                    'Leveraging AI-driven tools and platforms to support mentorship initiatives',
                    'Managing and leading remote and distributed teams',
                    'Leveraging AI-driven solutions to enhance remote team management and performance',
                    'Building diverse and inclusive tech teams through recruitment practices',
                    'Strategies for retaining top talent and reducing employee turnover',
                    'Leveraging AI-powered learning platforms and personalized development plans',
                ],
            },
            {
                title: 'Delivery problems',
                topics: [
                    'Implementing agile methodologies and other delivery frameworks',
                    'Managing technical debt and ensuring code quality',
                    'Estimating and planning project timelines and budgets',
                    'Managing risk and minimizing project failures',
                    'Scaling infrastructure and applications to meet demand',
                    'Improving the speed and reliability of software deployments',
                    'Ensuring compliance and security in software development',
                    'Tools and techniques for measuring and tracking tech debt in software development',
                    'Managing AI projects: challenges, risks, and mitigation strategies',
                    'AI-driven project risk analysis and mitigation strategies',
                ],
            },
            {
                title: 'Вiz results',
                topics: [
                    'Defining and measuring key performance indicators (KPIs)',
                    'Communicating technical progress and impact to non-technical stakeholders',
                    'Aligning technical goals with business objectives',
                    'Building a compelling product vision and roadmap',
                    'Using user feedback to inform product development',
                    'Managing stakeholders and building strong relationships with customers and partners',
                    'Sustainability transformation strategies',
                    'External tools and services management practices',
                    'Leveraging data analytics and AI in business analysis for improved decision-making',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What is the event about?</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;